import { graphql } from '../graphql/generated';

export const PRINT_VIA_AIS_MUTATION = graphql(`
  mutation PrintViaAis(
    $kind: AisPrintKind!
    $title: String!
    $content: String!
    $contentType: String!
    $copies: Int!
    $requestId: ID
    $orderId: ID
  ) {
    printViaAis(
      kind: $kind
      title: $title
      content: $content
      contentType: $contentType
      copies: $copies
      requestId: $requestId
      orderId: $orderId
    ) {
      jobId
      discardAfter
      discardInMillis
    }
  }
`);
